import BaseCRUDReducer from './CRUDReducer';
import {streamVideoAction} from '../actions/stream-video';

const CRUDReducer = new BaseCRUDReducer(streamVideoAction);

export default (state, action) => CRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/stream-video.js